import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

import { addressSerializeMap } from "lib/serializers/address";
import { insuranceRatesSerializeMap } from "lib/serializers/insuranceRates";
import { bankingDetailsSerializeMap } from "lib/serializers/bankingDetails";
import { paymentPreferencesSerializeMap } from "lib/serializers/paymentPreference";

const nestedEmailSettingsSerializeMap: SerializeMap<EmailSettings> = {
  salutation: "salutation",
  appendNameToSalutation: "append_name_to_salutation",
  body: "body",
};

const nestedReportSettingsSerializeMap: SerializeMap<ReportSettings> = {
  detailsText: "details_text",
  footerLayout: "footer_layout",
  headerLayout: "header_layout",
  primaryColor: "primary_color",
  secondaryColor: "secondary_color",
};

const trackingCategoryPreferenceSerializeMap: SerializeMap<TrackingCategoryPreference> =
  {
    id: "id",
    xeroTrackingCategoryOptionId: "xero_tracking_category_option_id",
    xeroTrackingCategoryId: "xero_tracking_category_id",
    dynamicOption: "dynamic_option",
  };

export const billingSettingsSerializeMap: SerializeMap<BillingSettings> = {
  id: "id",
  abn: "abn",
  accountSalePrefix: "account_sale_prefix",
  attachRfidReportWithBillingDocumentEmails:
    "attach_RFID_report_with_billing_document_emails",
  autoAcceptCosmeticChangesInDraft: "auto_accept_cosmetic_changes_in_draft",
  autoAcceptFinancialChangesInDraft: "auto_accept_financial_changes_in_draft",
  paymentBankingDetails: bankingDetailsSerializeMap,
  paymentPreferences: paymentPreferencesSerializeMap,
  bpayBillerCode: "bpay_biller_code",
  bpayBillerLongName: "bpay_biller_long_name",
  bpayBillerShortName: "bpay_biller_short_name",
  companyName: "company_name",
  contactPerson: "contact_person",
  debtorInsurance: insuranceRatesSerializeMap,
  defaultRetainedProceedsGlCode: "default_retained_proceeds_gl_code",
  emailAddress: "email_address",
  enableCompoundInterest: "enable_compound_interest",
  enableInterest: "enable_interest",
  faxNumber: "fax_number",
  financeReportLogoUrl: "finance_report_logo_url",
  generalEmailSettings: nestedEmailSettingsSerializeMap,
  includeExternalReferenceInXeroInvoiceNumber:
    "include_external_reference_in_xero_invoice_number",
  invoicePrefix: "invoice_prefix",
  nextAccountSaleNumber: "next_account_sale_number",
  nextInvoiceNumber: "next_invoice_number",
  nextRetainedProceedsNumber: "next_retained_proceeds_number",
  organizationName: "organization_name",
  paymentDirections: "payment_directions",
  phoneNumber: "phone_number",
  postalAddress: addressSerializeMap,
  rctiEmailSettings: nestedEmailSettingsSerializeMap,
  rctiSettings: nestedReportSettingsSerializeMap,
  rctiSummaryTitle: "rcti_summary_title",
  retainedProceedsPrefix: "retained_proceeds_prefix",
  showPaymentMethodInPerson: "show_payment_method_in_person",
  cardTransactionFeePercentage: "card_transaction_fee_percentage",
  showSplitDetailOnInvoice: "show_split_detail_on_invoice",
  showSplitDetailOnRCTI: "show_split_detail_on_rcti",
  splitRctiByBuyer: "split_rcti_by_buyer",
  groupRctis: "group_rctis",
  featureBuyerPaysVendor: "feature_buyer_pays_vendor",
  hideCentsPerKiloOnHeadSales: "hide_cents_per_kilo_on_head_sales",
  taxInvoiceEmailSettings: nestedEmailSettingsSerializeMap,
  taxInvoiceSettings: nestedReportSettingsSerializeMap,
  transitInsuranceForSales: insuranceRatesSerializeMap,
  transitInsuranceForPurchases: insuranceRatesSerializeMap,
  transitInsuranceApplicationDefault: "transit_insurance_application_default",
  transitInsuranceText: "transit_insurance_text",
  webAddress: "web_address",
  sendAgrinousLabels: "send_agrinous_labels",
  sendBusinessLabels: "send_business_labels",
  xeroLabelPrefix: "xero_label_prefix",
  xeroIntegrationCredentialId: "xero_integration_credential_id",
  trackingCategoryPreferences: trackingCategoryPreferenceSerializeMap,
};

export const nestedBillingSettingsSerializeMap = {
  debtor_insurance: "debtorInsurance",
  general_email_settings: "generalEmailSettings",
  payment_banking_details: "paymentBankingDetails",
  payment_preferences: "paymentPreferences",
  postal_address: "postalAddress",
  rcti_email_settings: "rctiEmailSettings",
  rcti_settings: "rctiSettings",
  tax_invoice_email_settings: "taxInvoiceEmailSettings",
  tax_invoice_settings: "taxInvoiceSettings",
  tracking_category_preferences: "trackingCategoryPreferences",
  transit_insurance_for_purchases: "transitInsuranceForPurchases",
  transit_insurance_for_sales: "transitInsuranceForSales",
};

export const serializeBillingSettings = buildSerializer(
  billingSettingsSerializeMap,
  "BillingSettings",
  nestedBillingSettingsSerializeMap,
);

export const deserializeBillingSettings = buildDeserializer(
  billingSettingsSerializeMap,
  "BillingSettings",
  nestedBillingSettingsSerializeMap,
);
